/*
 *
 * RefundsDetail constants
 *
 */

const BASE_CONSTANT = 'app/RefundsDetail';
export const DEFAULT_ACTION = `${BASE_CONSTANT}/DEFAULT_ACTION`;
export const VIEW_REFUND_TRANSACTION = `${BASE_CONSTANT}/VIEW_TRANSACTION`;
export const VIEW_REFUND_TIMELINE = `${BASE_CONSTANT}/VIEW_REFUND_TIMELINE`;
export const GET_WALLET_BALANCE = `${BASE_CONSTANT}/GET_WALLET_BALANCE`;
export const GET_WALLET_STATUS = `${BASE_CONSTANT}/GET_WALLET_STATUS`;
export const GET_BANK_ACCOUNTS = `${BASE_CONSTANT}/GET_BANK_ACCOUNTS`;

export const VIEW_REFUND_TRANSACTION_URL = {
  url: '/pg/transaction/view',
  method: 'GET',
};

export const VIEW_REFUND_TIMELINE_URL = {
  url: '/pg/refund/timeline',
  method: 'GET',
};

export const GET_WALLET_BALANCE_URL = {
  url: '/pg/recharge-amount',
  method: 'GET',
};

export const GET_WALLET_STATUS_URL = {
  url: '/pg/refunds/wallets/reference',
  method: 'GET',
};

export const CustomerDetailsKeys = [
  {
    key: 'Name',
    value: 'customerName',
  },
  {
    key: 'Email',
    value: 'customerEmail',
  },
  {
    key: 'Phone No.',
    value: 'customerPhone',
  },
  {
    key: 'Customer Ref ID',
    value: 'customerReferenceId',
  },
  {
    key: 'IP Address',
    value: 'customerIP',
  },
];

export const RefundDetails = [
  {
    header: 'CF Refund ID',
    value: 'cfRefundId',
  },
  {
    header: 'Refund ID',
    value: 'refundId',
  },
  {
    header: 'Refund ARN',
    value: 'refundARN',
  },
  {
    header: 'Refund Speed',
    value: 'currentSpeed',
  },

  // {
  //   header: 'Refund Initiated On',
  //   value: 'addedOn',
  // },
  // {
  //   header: 'Refund Speed',
  //   value: 'currentSpeed',
  // },
];

export const REFUNDED = 'REFUNDED';

export const REFUND_SPEED = 'Refund Speed';

export const STANDARD = 'STANDARD';
export const INSTANT = 'INSTANT';

export const REFUND_ARN = 'Refund ARN';

export const ONHOLD = 'ONHOLD';

export const ACTIVE = 'active';
